import { useAssets } from '../../queries';

export interface DashboardStats {
  total: number;
  images: number;
  documents: number;
  videos: number;
  isLoading: boolean;
}

/**
 * Headline counts for the dashboard stat strip.
 *
 * Each figure comes from `pagination.totalCount` on a `pageSize: 1` query, so
 * the backend does the counting and we transfer one row per kind rather than
 * pulling the whole gallery down to call `.length` on it. React Query dedupes
 * and caches these alongside every other asset query.
 */
export function useDashboardStats(): DashboardStats {
  const all = useAssets({ pageSize: 1 });
  const images = useAssets({ kind: 'image', pageSize: 1 });
  const documents = useAssets({ kind: 'document', pageSize: 1 });
  const videos = useAssets({ kind: 'video', pageSize: 1 });

  return {
    total: all.data?.pagination.totalCount ?? 0,
    images: images.data?.pagination.totalCount ?? 0,
    documents: documents.data?.pagination.totalCount ?? 0,
    videos: videos.data?.pagination.totalCount ?? 0,
    isLoading:
      all.isLoading || images.isLoading || documents.isLoading || videos.isLoading,
  };
}
